import { Directive, ElementRef, inject, Input, OnDestroy } from '@angular/core';
import { AccessRightsService } from '../services/access-rights.service';
import { Policy } from '../../shared/models/info/policy';
import { Subscription } from 'rxjs';
import { ExtendedPolicy } from '../../shared/models/info/extended-policy';

@Directive({
  selector: '[appEnabledByPolicy]',
  standalone: true,
})
export class EnabledByPolicyDirective implements OnDestroy {
  private subscription: Subscription | null = null;
  private accessRightsService: AccessRightsService = inject(AccessRightsService);

  private readonly element: ElementRef = inject(ElementRef);

  // Hint: Seems the name must match selector
  @Input() public set appEnabledByPolicy(config: Policy | ExtendedPolicy) {
    this.subscription?.unsubscribe();

    const policy = Array.isArray(config) ? (config as ExtendedPolicy)[0] : (config as Policy);
    const disabled = Array.isArray(config) ? (config as ExtendedPolicy)[1] : false;

    this.subscription = this.accessRightsService.isPolicySatisfied$(policy).subscribe((satisfied) => {
      this.setElementDisabled(!satisfied || disabled);
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private setElementDisabled(disabled: boolean): void {
    this.element.nativeElement.disabled = disabled;
  }
}
